export default __webpack_public_path__ + "static/media/mobile_banner_personal.7c528742.jpg";